import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './TableCellSubdomainActions.css';
import Icon, { IconTypes } from '../../../../../components/foundations/Icon';
import Button from '../../../../../components/atoms/Button';
import Tooltip from '../../../../../components/molecules/Tooltip';
import { STATUSES } from '../consts';

const translationPrefix = 'STATIC.PAGES.MANAGE_LINKS';
// Validates domains with at least one subdomain (e.g., a.b.com, a.b.co.uk, a.b-x.co.uk)
const BRANDED_DOMAIN_REGEXP = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

const TableCellSubdomainActions = props => {
    const { tdClassName, rowIndex, row, onCreateCancelClick, onArchiveClick, onFavouriteClick, onCreateClick } = props;

    const {
        isFavourite,
        isCreatingDomain,
        status,
        isBrandedDomain,
        isRowDisabled,
        isCreatingButtonDisabled,
        isLoading,
        subdomain,
    } = row;

    const isArchiveDisabled = isBrandedDomain && [STATUSES.LIVE, STATUSES.PENDING_CERTIFICATE].includes(status);

    const _onArchiveClick = () => {
        if (isArchiveDisabled) return;
        onArchiveClick(row);
    };

    const renderContent = () => {
        if (isCreatingDomain && rowIndex === 0) {
            return (
                <div className={css.createContainer}>
                    <Button
                        showSpinner={isLoading}
                        disabled={
                            isCreatingButtonDisabled ||
                            isRowDisabled ||
                            (isBrandedDomain && !BRANDED_DOMAIN_REGEXP.test(subdomain))
                        }
                        onClick={() => onCreateClick(row)}
                        type="secondary"
                    >
                        <Translate id={`${translationPrefix}.SUB_DOMAIN.TABLE.ACTIONS.CREATE`} />
                    </Button>
                    <Icon onClick={onCreateCancelClick} name="close-fill" type={IconTypes.MINGCUTE} />
                </div>
            );
        }

        if (status === STATUSES.PENDING_CNAME && isBrandedDomain) {
            return (
                <div className={css.actionsContainer}>
                    <Button showSpinner={isLoading} onClick={() => onCreateClick(row)} type="secondary" size="small">
                        <Translate id={`${translationPrefix}.SUB_DOMAIN.TABLE.ACTIONS.VALIDATE`} />
                    </Button>
                    <Tooltip titleTranslationKey="STATIC.TOOLTIPS.ARCHIVE">
                        <Icon
                            onClick={() => _onArchiveClick(row)}
                            className={isArchiveDisabled ? css.active : css.notActive}
                            name="archive"
                            type={IconTypes.TABLER}
                        />
                    </Tooltip>
                </div>
            );
        }

        if (status === STATUSES.PENDING_CERTIFICATE && isBrandedDomain) {
            return (
                <div className={css.actionsContainer}>
                    <Translate id={`${translationPrefix}.SUB_DOMAIN.TABLE.ACTIONS.WAITING`} />
                </div>
            );
        }

        return (
            <div className={css.actionsContainer}>
                {isFavourite ? (
                    <Icon
                        onClick={() => onFavouriteClick(row)}
                        className={css.active}
                        name="star-off"
                        type={IconTypes.TABLER}
                    />
                ) : (
                    <Tooltip titleTranslationKey={`${translationPrefix}.DEFAULT_TOOLTIP`}>
                        <Icon
                            onClick={() => onFavouriteClick(row)}
                            className={css.notActive}
                            name="star"
                            type={IconTypes.TABLER}
                        />
                    </Tooltip>
                )}
                <Tooltip titleTranslationKey="STATIC.TOOLTIPS.ARCHIVE">
                    <Icon
                        onClick={() => _onArchiveClick(row)}
                        className={isArchiveDisabled ? css.active : css.notActive}
                        name="archive"
                        type={IconTypes.TABLER}
                    />
                </Tooltip>
            </div>
        );
    };

    return <td className={classNames(tdClassName, isCreatingDomain ? css.backgroundCreate : '')}>{renderContent()}</td>;
};

TableCellSubdomainActions.propTypes = {
    row: PropTypes.object,
    tdClassName: PropTypes.string,
    rowIndex: PropTypes.number,
    onCreateClick: PropTypes.func,
    onArchiveClick: PropTypes.func,
    onCreateCancelClick: PropTypes.func,
    onFavouriteClick: PropTypes.func,
    subDomainsPageData: PropTypes.objectOf({ working: PropTypes.bool }),
};

export default TableCellSubdomainActions;
